<script setup lang="ts">
import { onUnmounted } from 'vue';

import TableFooterBar from '@/components/bars/TableFooterBar.vue';
import KBtn from '@/components/btns/KBtn.vue';
import ChatMainSendForm from '@/components/forms/ChatMainSendForm.vue';
import ChatRosterSideBarForm from '@/components/forms/ChatRosterSideBarForm.vue';
import SmsChatDetailsSection from '@/components/sections/SmsChatDetailsSection.vue';
import SmsChatMessagesSection from '@/components/sections/SmsChatMessagesSection.vue';
import SmsChatRecipientSection from '@/components/sections/SmsChatRecipientSection.vue';
import SmsChatRosterSection from '@/components/sections/SmsChatRosterSection.vue';
import useSmsChatViewData from '@/composables/data/useSmsChatViewData';
import useSmsRouteQuery from '@/composables/routeQueries/useSmsRouteQuery';
import { useSmsChatViewStore } from '@/stores/useSmsChatViewStore';

const routeQuery = useSmsRouteQuery({});

const smsChatViewStore = useSmsChatViewStore();
smsChatViewStore.init(useSmsChatViewData(routeQuery), routeQuery);

onUnmounted(function () {
  smsChatViewStore.$reset();
});
</script>

<template>
  <div :class="$style.smsChatView" data-testid="smsChatView">
    <div :class="$style.content">
      <div :class="$style.roster">
        <ChatRosterSideBarForm
          :initial-data="smsChatViewStore.chatRosterSideBarFormInitialData"
          :class="$style.sideBarForm"
          @submit="smsChatViewStore.handleChatRosterSideBarFormSubmit"
        />
        <SmsChatRosterSection
          :messagePreviews="smsChatViewStore.messagePreviews"
        />
      </div>
      <div :class="$style.main">
        <div v-if="smsChatViewStore.recipientName" :class="$style.recipient">
          <SmsChatRecipientSection
            :name="smsChatViewStore.recipientName"
            :datetime="smsChatViewStore.recipientDatetime"
          />
        </div>
        <SmsChatMessagesSection
          :class="$style.messages"
          :messages="smsChatViewStore.messages"
          :loading="smsChatViewStore.data.isFetchingMessageHistoryData"
        />
        <div :class="$style.compose">
          <ChatMainSendForm
            :initial-data="smsChatViewStore.chatMainSendFormInitialData"
            :loading="smsChatViewStore.data.isFetchingSendData"
            @submit="smsChatViewStore.handleChatMainSendFormSubmit"
          />
        </div>
      </div>
      <div :class="$style.details">
        <SmsChatDetailsSection
          v-if="smsChatViewStore.recipientName"
          v-bind="smsChatViewStore.details"
        />
      </div>
    </div>
    <TableFooterBar>
      <KBtn
        size="lg"
        append-icon="mdi-pencil-outline"
        :disabled="false"
        :loading="false"
        @click="smsChatViewStore.handleCreateNewMessageClick"
      >
        Create new message
      </KBtn>
    </TableFooterBar>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.smsChatView {
}
  .content {
    display: flex;
    width: 100%;
    height: calc(100vh - variables.$appBarHeight - variables.$tableFooterHeight + 1px);
    background-color: colors.$color-white;
  }
    .roster {
      width: 100%;
      min-width: 220px;
      max-width: 440px;
      overflow-y: auto;
      padding: 24px;
    }
      .sideBarForm {
        margin-bottom: 12px;
      }
    .main {
      width: 100%;
      min-width: 352px;
      max-width: 704px;
      border-left: 1px solid colors.$color-brand-50;
      border-right: 1px solid colors.$color-brand-50;
      display: flex;
      flex-direction: column;
      padding-top: 12px;
    }
      .recipient {
        padding: 24px;
      }
      .messages {
        height: 100%;
        overflow-y: auto;
        padding: 0 12px 0 12px;
      }
      .compose {
        margin: 24px 0;
        padding: 24px;
        border-top: 1px solid colors.$color-brand-50;
        height: 102px;
        max-height: 50%;
      }
    .details {
      padding: 24px;
      width: 100%;
      min-width: 190px;
      max-width: 380px;
    }
</style>
